import Image from 'next/image'
import Link from 'next/link'

import { Drawer } from '@/components/primitives/Drawer/Drawer'
import DynamicIcon from '@/components/primitives/DynamicIcon/DynamicIcon'
import { getImageUrl } from '@/lib/utils'

import type { LinkEntry } from '@/types/contentful/headerType'

export const MenuLink = ({ link }: { link: LinkEntry }) => {
  const { label, url, image, icon } = link.fields

  return (
    <Drawer.Close>
      <Link
        href={url}
        key={label}
        className="group flex w-full items-center gap-4 text-base font-medium text-grey-700 transition-colors hover:text-primary-500 hover:underline hover:underline-offset-4 focus-visible:text-primary-500 focus-visible:underline focus-visible:underline-offset-4 focus-visible:outline-none"
      >
        {(icon || image) && (
          <div className="flex size-[56px] items-center justify-center rounded-full bg-gray-100 transition-colors group-hover:bg-primary-500 group-focus-visible:bg-primary-500">
            {image ? (
              <Image src={getImageUrl(image)} alt="Logo" width={48} height={48} className="aspect-[1/1] rounded-full object-contain" />
            ) : (
              icon && <DynamicIcon name={icon} size={28} className="text-primary-500 transition-colors group-hover:text-white group-focus-visible:text-white" />
            )}
          </div>
        )}

        {label}
      </Link>
    </Drawer.Close>
  )
}
